import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import PropertyList from './PropertyList';
import PropertyDetails from '../pages/PropertyDetails';
import PropertyDetailsSkeleton from './PropertyDetailsSkeleton';
import PreLoader from './PreLoader';
import NotFound from '../pages/NotFound';
import {
  extractPropertyIdFromParam,
  isLegacyPropertyIdOnlySegment,
} from '../utils/seo/urlHelpers';

/**
 * Resolve /propriedades/:slugAndId:
 *  - detalhe: /propriedades/{slug}-{id}
 *  - listagem por cidade: /propriedades/campo-grande
 *  - URL legada só com ID: 404 (sem redirect)
 */
export default function PropertyRouteResolver() {
  const { slugAndId, seg1 } = useParams();
  const segment = slugAndId || seg1;
  const isLegacyIdOnly = isLegacyPropertyIdOnlySegment(segment);
  const propertyId = isLegacyIdOnly ? null : extractPropertyIdFromParam(segment);
  const [mode, setMode] = useState(() => {
    if (isLegacyIdOnly) return 'notfound';
    return propertyId ? 'checking' : 'listing';
  });

  useEffect(() => {
    let active = true;

    if (isLegacyIdOnly) {
      setMode('notfound');
      return undefined;
    }

    if (!propertyId) {
      setMode('listing');
      return undefined;
    }

    setMode('checking');
    (async () => {
      try {
        const db = getFirestore();
        const snap = await getDoc(doc(db, 'properties', propertyId));
        if (!active) return;
        setMode(snap.exists() ? 'detail' : 'listing');
      } catch (error) {
        if (active) setMode('listing');
      }
    })();

    return () => {
      active = false;
    };
  }, [propertyId, isLegacyIdOnly]);

  if (mode === 'notfound') {
    return <NotFound />;
  }

  if (mode === 'checking') {
    return (
      <>
        <PreLoader isLoading onLoadingComplete={() => {}} />
        <PropertyDetailsSkeleton />
      </>
    );
  }

  if (mode === 'detail') {
    return <PropertyDetails propertyId={propertyId} />;
  }

  return <PropertyList />;
}
